import React, { useState } from 'react';
import { Modal, Box, TextField, Button, Typography, InputAdornment, Stack } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const ChangePassword = ({ open, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [errors, setErrors] = useState({
        newPassword: '',
        confirmPassword: '',
    });

    const validatePasswords = () => {
        let isValid = true;
        const newErrors = { newPassword: '', confirmPassword: '' };

        const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
        if (!passwordRegex.test(formData.newPassword)) {
            newErrors.newPassword = 'Password must be at least 8 characters, include a capital letter, and a number';
            isValid = false;
        }
        if (formData.newPassword !== formData.confirmPassword) {
            newErrors.confirmPassword = 'New password and confirm password do not match';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = () => {
        if (validatePasswords()) {
            onSubmit(formData);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Typography fontFamily="GveretLevin" direction="rtl" textAlign="right" variant="h6" mb={2}>
                    שנה סיסמה
                </Typography>
                <TextField
                    fullWidth
                    margin="normal"
                    label="סיסמה נוכחית"
                    type="password"
                    value={formData.currentPassword}
                    onChange={(e) => setFormData({ ...formData, currentPassword: e.target.value })}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="סיסמה חדשה"
                    type="password"
                    value={formData.newPassword}
                    onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
                    error={!!errors.newPassword}
                    helperText={errors.newPassword}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="הזן את היסמה מחדש"
                    type="password"
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={onClose}
                        sx={{
                            color: '#C4A484'
                            , border: '#C4A484'
                        }}                    >
                        ביטול
                    </Button>
                    <Button
                        variant="contained"
                        fullWidth
                        sx={{
                            backgroundColor: "#C4A484",
                            "&:hover": { backgroundColor: "#C4A484" },
                        }}
                        onClick={handleSubmit}
                    >
                        שליחה
                    </Button>

                </Stack>
            </Box>
        </Modal>
    );
};

export default ChangePassword;
